export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14501.6b01b1e9.jpg";